import styled from "styled-components"

const Main = styled.main`
  margin: 0 auto;
`

export default Main
